import { z } from 'zod'
import { ServiceStatus } from '~/enums/service-status'

/**
 * 問題答覆 - 單筆資料 Schema
 */
export const serviceIssueDataSchema = z.object({
  /** 技術服務問題ID */
  siID: z.number(),
  /** 產品主類目代碼 */
  pmCode: z.string(),
  /** 產品主類目ID */
  pmID: z.number(),
  /** 產品主類目(中) */
  pmNameZh: z.string(),
  /** 產品主類目(英) */
  pmNameEn: z.string(),
  /** 產品版本 */
  productVersion: z.string(),
  /** 問題分類 */
  serviceClass: z.string(),
  /** 問題分類(中) */
  serviceClassZh: z.string().nullable(),
  /** 問題分類(英) */
  serviceClassEn: z.string().nullable(),
  /** 提問時間 */
  createDate: z.string(),
  /** 提問人 */
  whoAsk: z.string(),
  /** 問題標題 */
  topic: z.string(),
  /** 問題內容 */
  content: z.string(),
  /** 問題層級 */
  serviceUrgent: z.string().nullable(),
  /** 是否結案 */
  serviceStatus: z.nativeEnum(ServiceStatus),
  /** 問題狀態排序 */
  serviceStatusSort: z.number(),
  /** 問題狀態(中) */
  serviceStatusZh: z.string(),
  /** 問題狀態(英) */
  serviceStatusEn: z.string(),
  /** 答覆人員 */
  reply: z.string().nullable(),
  /** 答覆時間 */
  replyDate: z.string().nullable(),
  /** 作業系統 */
  osType: z.string()
})

/**
 * 問題答覆 - 單筆資料
 */
export type ServiceIssueData = z.infer<typeof serviceIssueDataSchema>
